module.exports = __webpack_public_path__ + "img/buessiness_yywl_h1.c723ae75.png";